import request from '@/router/axios';

/** 应急事件详情（含预案、派工列表） */
export const getEventDetail = (eventId) => {
  return request({
    url: '/api/produce/emergency-event/getDetail',
    method: 'get',
    params: { eventId }
  });
};

/** 分页列表（选事件用） */
export const getEventPage = (params) => {
  return request({
    url: '/api/produce/emergency-event/select/page',
    method: 'get',
    params
  });
};
